import PropTypes from "prop-types";
import styles from "./SnackBar.module.scss";
import config from "../../../config/index";
import CTAButton from "../CTAButton/CTAButton";

const SnackBarWithButton = (props) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  return (
    <div
      className={props.isVisible ? `${styles.snackBar} ${props.className}` : ""}
    >
      <div className={styles.snackBar__titleContainer}>
        <label className={styles.snackBar__title}>{props.title}</label>
        <img
          className={styles.snackBar__titleContainer__closeImage}
          onClick={props.closeSnackBar}
          src={`${imagePrefix}/assets/images/close-white.svg`}
          alt="placeholder"
        />
      </div>
      <label className={styles.snackBar__description}>
        {props.description}
      </label>
      <CTAButton
        variant="solid white"
        className={styles.snackBar__button}
        handleClick={() => props.buttonHandler()}
      >
        {props.btnText}
      </CTAButton>
    </div>
  );
};

SnackBarWithButton.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  btnText: PropTypes.string,
  style: PropTypes.object,
  closeSnackBar: PropTypes.func,
  isVisible: PropTypes.bool,
  className: PropTypes.string,
  buttonHandler: PropTypes.func,
};

export default SnackBarWithButton;
